import { api } from './api';

export interface AttemptSummary {
  attemptId: number;
  studentId: number;
  studentName: string;
  scoreCorrect: number;
  scoreTotal: number;
  scorePercent: number;
  submittedAt: string;
  attemptNumber: number;
}

export interface TutorTestResults {
  testId: number;
  testName: string;
  scheduledDate: string;
  averageScore: number | null;
  attemptCount: number;
  studentCount: number;
  attempts: AttemptSummary[];
}

export interface TutorOptionDetail {
  index: number;
  text: string;
  isCorrect: boolean;
}

export interface TutorQuestionDetail {
  snapshotQuestionId: number;
  nodeId: number;
  topicLabel: string | null;
  questionText: string;
  options: TutorOptionDetail[];
  selectedOptionIndex: number | null;
  isCorrect: boolean;
  explanation: string | null;
}

export interface TutorStudentAttemptDetail {
  attemptId: number;
  studentId: number;
  studentName: string;
  scoreCorrect: number;
  scoreTotal: number;
  submittedAt: string;
  questions: TutorQuestionDetail[];
}

export const getTestResults = async (courseId: number, testId: number): Promise<TutorTestResults> => {
  const res = await api.get<{ data: TutorTestResults }>(
    `/api/tutor/courses/${courseId}/tests/${testId}/results`,
  );
  return res.data.data;
};

export const getTutorAttemptDetail = async (
  courseId: number,
  testId: number,
  studentId: number,
  attemptId: number,
): Promise<TutorStudentAttemptDetail> => {
  const res = await api.get<{ data: TutorStudentAttemptDetail }>(
    `/api/tutor/courses/${courseId}/tests/${testId}/results/students/${studentId}/attempts/${attemptId}`,
  );
  return res.data.data;
};
